export const LOAD_SETTINGS = 'LOAD_SETTINGS';
export const UPDATE_KEY = 'UPDATE_KEY';
export const GET_COMMON_AI_ADMIN_FEEDBACK_TEMPLATES =
  'GET_COMMON_AI_ADMIN_FEEDBACK_TEMPLATES';
